import React from 'react';
import '../../style/quote.css';
import WizardStepHeader from "./wizardStepheader";
import PreviousWizardStepButton from "./previousWizardStepButton";
import WizardStep1 from "./wizardStep1";
import WizardStep2 from "./wizardStep2";
import WizardStep3 from "./wizardStep3";
import WizardStep4 from "./wizardStep4";
import WizardStep5 from "./wizardStep5";
import CenteredDots from "../General/centeredDots";
import { POLICYHOLDER_TEXT } from '../../helpers/variables';


const headerItems = [
    {name:`${POLICYHOLDER_TEXT} Details`, key: 0},
    {name:'Quote Options', key: 1},
    {name:'Quote Complete', key: 2},
    // {name:'Hold Cover', key: 3},
];

const Quote = (props) => {
    if(props.fetchingQuote){
        return (
            <div className={'col-sm-12'}>
                <CenteredDots/>
            </div>
        )
    }
    const quoteHeading = props._getQuoteMessageByPosition('QuickQuoteHeading');
    const stepTitle = props._getQuoteStepTitle();
    return (
        <div className={'mb-15'}>
            <div className={'row'}>
                <h2 className="col-sm-12 applicationsAndPolicies-h2">{quoteHeading.title}</h2>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12 mb-15'} dangerouslySetInnerHTML={{__html: quoteHeading.body}}>
                </div>
            </div>
            <div className={'row'}>
                <h3 className="col-sm-12 applicationPolicy-h2">{stepTitle}</h3>
            </div>
            <div className={'row'}>
                <div className={'col-sm-12 mb-15'}>
                    <WizardStepHeader {...props} headerItems={headerItems} />
                </div>
                {props.wizardStep > 0 && (
                    <div className={'col-sm-12 mb-15'}>
                        <PreviousWizardStepButton {...props} previousStepName={headerItems[props.wizardStep - 1].name}/>
                    </div>
                )}
                <div className={'col-sm-12'}>
                    <div onSubmit={evt => evt.preventDefault()}>
                        {props.wizardStep === 0 && (
                            <WizardStep1 {...props}/>
                        )}
                        {props.wizardStep === 1 && (
                            <WizardStep2 {...props}/>
                        )}
                        {props.wizardStep === 2 && (
                            <WizardStep3 {...props}/>
                        )}
                        {/*{props.wizardStep === 3 && (*/}
                        {/*    <WizardStep4 {...props}/>*/}
                        {/*)}*/}
                        {/*{props.wizardStep === 4 && (*/}
                        {/*    <WizardStep5 {...props}/>*/}
                        {/*)}*/}
                    </div>
                </div>
                {props.wizardStep > 0 && (
                    <div className={'col-sm-12 mt-15'}>
                        <PreviousWizardStepButton {...props} previousStepName={headerItems[props.wizardStep - 1].name}/>
                    </div>
                )}
            </div>
        </div>
    )
};

export default Quote;
